var _defs, _path, _rect, _rect2, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .st1 {\r\n        fill: #2c3948;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.3,29.7h13.4v-2.8h-13.4v2.8ZM13.3,22.8h13.4v-2.8h-13.4v2.8ZM9.4,36.7c-.8,0-1.4-.3-2-.8-.6-.6-.8-1.2-.8-2V6.1c0-.7.3-1.4.8-2,.6-.6,1.2-.8,2-.8h14.5l9.4,9.4v21.1c0,.8-.3,1.4-.8,2-.6.6-1.2.8-2,.8H9.4Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 13.3,
    y: 20,
    width: 13.4,
    height: 2.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 13.3,
    y: 26.9,
    width: 13.4,
    height: 2.8
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "22.7 5.5 22.7 13.5 30.7 13.5 22.7 5.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.a4b183a29a5ef8982c6995cf67554f65.svg";
export { ForwardRef as ReactComponent };